export default __webpack_public_path__ + "3dd7b16cc6e03a55c232a3d9f4f231d7.png";